import { type Dispatch, useContext } from "react";
import {
  PageViewedActions,
  PageViewedContext,
  PageViewedDispatch,
  PageViewedState,
} from "src/contexts/page-viewed.context";

export function usePageViewedContext(): PageViewedState {
  const pageViewedContext = useContext(PageViewedContext);

  if (typeof pageViewedContext === "undefined") {
    throw new Error(
      "Please make sure you use usePageViewedContext inside PageViewedContextProvider."
    );
  }

  return pageViewedContext;
}

export function usePageViewedDispatch(): Dispatch<PageViewedActions> {
  const pageViewedDispatch = useContext(PageViewedDispatch);

  if (!pageViewedDispatch) {
    throw new Error(
      "Please make sure you use usePageViewedContextDispatch inside PageViewedContextProvider."
    );
  }

  return pageViewedDispatch;
}
